import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const NDI_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.NDI,
  title: 'Neck Disability Index (NDI)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'dolore_intensita',
      'cura_personale',
      'sollevamento',
      'lettura',
      'mal_di_testa',
      'concentrazione',
      'lavoro',
      'guida',
      'sonno',
      'tempo_libero',
    ],
  },
  sections: [
    {
      name: 'ndi',
      label: 'Neck Disability Index',
      fields: [
        {
          key: 'dolore_intensita',
          label: 'Intensità del dolore',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Non ho dolore al collo.',
            1: 'Il dolore è molto lieve.',
            2: 'Il dolore è lieve.',
            3: 'Il dolore è moderato.',
            4: 'Il dolore è intenso.',
            5: 'Il dolore è il peggiore possibile.',
          },
          description: 'Livello di dolore percepito al collo.',
        },
        {
          key: 'cura_personale',
          label: 'Cura personale',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Posso prendermi cura di me stesso normalmente senza dolore.',
            1: 'Posso prendermi cura di me stesso normalmente ma con un po’ di dolore.',
            2: 'Prendermi cura di me stesso causa dolore.',
            3: 'È doloroso e lento prendermi cura di me stesso.',
            4: 'Ho bisogno di aiuto per alcune attività di cura personale.',
            5: 'Ho bisogno di aiuto per la maggior parte delle attività di cura personale.',
          },
          description: 'Capacità di svolgere attività di cura personale.',
        },
        {
          key: 'sollevamento',
          label: 'Sollevamento',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Posso sollevare oggetti pesanti senza dolore.',
            1: 'Posso sollevare oggetti pesanti ma con dolore.',
            2: 'Il dolore mi impedisce di sollevare oggetti pesanti dal pavimento, ma posso sollevarli da un piano.',
            3: 'Il dolore limita il sollevamento a oggetti leggeri.',
            4: 'Posso sollevare solo oggetti molto leggeri.',
            5: 'Non posso sollevare alcun oggetto.',
          },
          description: 'Capacità di sollevare oggetti.',
        },
        {
          key: 'lettura',
          label: 'Lettura',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Posso leggere senza dolore.',
            1: 'Posso leggere con un po’ di dolore.',
            2: 'Posso leggere finché voglio ma con dolore moderato.',
            3: 'Posso leggere solo per un tempo limitato a causa del dolore.',
            4: 'Il dolore quasi sempre impedisce la lettura.',
            5: 'Non posso leggere a causa del dolore.',
          },
          description: 'Capacità di leggere senza peggioramento del dolore.',
        },
        {
          key: 'mal_di_testa',
          label: 'Mal di testa',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            0: 'Non ho mal di testa.',
            1: 'Ho mal di testa lieve e poco frequente.',
            2: 'Ho mal di testa moderato e poco frequente.',
            3: 'Ho mal di testa frequente.',
            4: 'Ho mal di testa quasi quotidiano.',
            5: 'Ho mal di testa costante e molto intenso.',
          },
          description: 'Frequenza e intensità dei mal di testa.',
        },
        {
          key: 'concentrazione',
          label: 'Concentrazione',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Posso concentrarmi senza difficoltà.',
            '1': 'Posso concentrarmi con lieve dolore.',
            '2': 'Il dolore interferisce un po’ con la concentrazione.',
            '3': 'Il dolore rende difficile concentrarsi per lungo tempo.',
            '4': 'La concentrazione è molto limitata dal dolore.',
            '5': 'Non riesco a concentrarmi a causa del dolore.',
          },
          description: 'Capacità di concentrarsi.',
        },
        {
          key: 'lavoro',
          label: 'Lavoro',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Posso lavorare normalmente.',
            '1': 'Posso lavorare normalmente ma con un po’ di dolore.',
            '2': 'Il dolore mi impedisce di svolgere lavori pesanti.',
            '3': 'Il dolore limita il lavoro a compiti leggeri.',
            '4': 'Posso lavorare solo per brevi periodi.',
            '5': 'Non posso lavorare.',
          },
          description: 'Impatto del dolore sulle attività lavorative.',
        },
        {
          key: 'guida',
          label: 'Guida',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Posso guidare senza dolore.',
            '1': 'Posso guidare con un po’ di dolore.',
            '2': 'Posso guidare finché voglio ma con dolore moderato.',
            '3': 'Posso guidare solo per brevi periodi a causa del dolore.',
            '4': 'Il dolore quasi sempre impedisce la guida.',
            '5': 'Non posso guidare.',
          },
          description: 'Capacità di guidare senza dolore.',
        },
        {
          key: 'sonno',
          label: 'Sonno',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Il mio sonno non è disturbato dal dolore.',
            '1': 'Il mio sonno è leggermente disturbato.',
            '2': 'Il mio sonno è moderatamente disturbato.',
            '3': 'Il mio sonno è molto disturbato.',
            '4': 'Dormo meno della metà della notte a causa del dolore.',
            '5': 'Non riesco a dormire a causa del dolore.',
          },
          description: 'Qualità del sonno influenzata dal dolore.',
        },
        {
          key: 'tempo_libero',
          label: 'Attività del tempo libero',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Posso svolgere tutte le attività del tempo libero.',
            '1': 'Posso svolgere le attività del tempo libero con un po’ di dolore.',
            '2': 'Il dolore limita alcune attività del tempo libero.',
            '3': 'Il dolore limita molte attività del tempo libero.',
            '4': 'Posso svolgere solo poche attività del tempo libero.',
            '5': 'Non posso svolgere alcuna attività del tempo libero.',
          },
          description: 'Capacità di svolgere attività ricreative.',
        },
      ],
    },
  ],
  computedFields: [
    {
      key: 'totale',
      label: 'Punteggio totale',
      type: 'number',
      calculation: 'SUM(scoreConfig.sumOf)',
      maxScore: 50,
    },
  ],
};
